var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 325,
    viewBox: "0 0 327 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.675 253.129L138.867 191.054H206.251L289.349 245.7",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.675 253.129L138.867 191.054H206.251L289.349 245.7",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.777 250.685L138.867 195.195V191.054L168.448 256.022L159.777 250.685Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.394 193.622L206.056 227.117L171.265 235.196L151.497 197.756L177.394 193.622Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.265 235.196V236.184L205.463 229.287L206.056 227.116L171.265 235.196Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.312 205.673L177.779 207.831L181.508 206.824L179.956 204.718L176.312 205.673Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.427 218.874L188.654 216.482L184.416 217.62L186.072 220.064L190.427 218.874Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.267 201.175L174.355 202.787L177.863 201.896L176.761 200.401L173.267 201.175Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.021 211.139L182.03 214.103L186.131 213.07L183.914 210.073L180.021 211.139Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.643 212.531L187.128 213.421L188.889 215.8L192.468 214.838L190.643 212.531Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.388 214.623L184.064 217.106L188.276 215.969L186.509 213.577L182.388 214.623Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.296 202.053L170.378 203.795L173.743 202.937L172.641 201.312L169.296 202.053Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.124 208.345L179.676 210.626L183.536 209.56L181.886 207.331L178.124 208.345Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.708 203.301L175.959 205.153L179.571 204.204L178.241 202.404L174.708 203.301Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.118 207.48L166.023 205.51L162.026 206.524L163.141 208.526L167.118 207.48Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.374 212.244L164.119 211.51L162.848 209.222L160.148 209.93L161.374 212.244Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.109 200.141L168.964 201.519L172.282 200.785L171.389 199.472L168.109 200.141Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.723 204.971L164.667 203.073L160.605 203.963L161.726 205.985L165.723 204.971Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.165 200.941L164.974 202.397L168.351 201.656L167.484 200.265L164.165 200.941Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.486 206.811L161.133 206.135L159.999 204.1L157.358 204.679L158.486 206.811Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.458 201.903L160.305 203.424L164.367 202.533L163.552 201.064L159.458 201.903Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.217 206.752L173.586 208.955L177.172 207.993L175.705 205.835L172.217 206.752Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M181.423 214.26L179.421 211.309L175.686 212.336L177.498 215.254L181.423 214.26Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.273 202.936L166.317 204.821L169.772 203.944L168.683 202.189L165.273 202.936Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M166.055 214.981L163.239 215.754L164.699 218.504L167.601 217.769L166.055 214.981Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.912 209.482L175.36 211.809L179.069 210.795L177.524 208.507L173.912 209.482Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.291 206.388L170.098 204.47L166.616 205.354L167.712 207.33L171.291 206.388Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M177.831 226.765L173.847 227.779L175.269 230.334L179.265 229.352L177.831 226.765Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M171.663 198.815L175.073 198.12L173.241 195.637L169.883 196.189L171.663 198.815Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.252 200.525L161.603 197.554L157.423 198.243L159.158 201.363L163.252 200.525Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.676 210.281L167.418 208.013L163.441 209.059L164.712 211.347L168.676 210.281Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M178.828 218.517L177.224 215.937L173.078 216.99L174.564 219.668L178.828 218.517Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M176.898 215.41L175.086 212.498L171.18 213.571L172.778 216.45L176.898 215.41Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.457 217.269L181.775 214.78L177.824 215.781L179.428 218.355L183.457 217.269Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.986 209.118L171.617 206.908L168.005 207.863L169.263 210.119L172.986 209.118Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M170.705 204.321L171.891 206.226L175.353 205.316L174.095 203.457L170.705 204.321Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M174.76 211.978L173.312 209.645L169.557 210.652L170.887 213.044L174.76 211.978Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M185.472 220.233L183.809 217.789L179.754 218.881L181.299 221.371L185.472 220.233Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.793 224.893L181.026 222.053L176.566 223.275L178.131 226.076L182.793 224.893Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M169.426 221.052L167.901 218.302L164.986 219.043L166.473 221.851L169.426 221.052Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M164.419 212.043L161.661 212.784L162.959 215.221L165.756 214.454L164.419 212.043Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M177.531 226.232L175.979 223.431L172.028 224.51L173.547 227.24L177.531 226.232Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M170.294 213.2L168.97 210.814L165.006 211.88L166.349 214.292L170.294 213.2Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M172.021 199.342L172.908 200.648L176.377 199.881L175.458 198.64L172.021 199.342Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.071 204.139L159.699 203.56L158.851 202.026L156.23 202.559L157.071 204.139Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M167.77 199.602L171.03 198.939L169.237 196.293L166.042 196.82L167.77 199.602Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.865 200.402L167.157 199.732L165.41 196.924L162.222 197.451L163.865 200.402Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M162.555 208.689L161.433 206.674L158.773 207.35L159.862 209.391L162.555 208.689Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.712 197.99L178.659 197.386L176.807 195.052L173.893 195.527L175.712 197.99Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.545 201.487L156.797 198.341L154.215 198.77L155.943 202.014L158.545 201.487Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.254 227.929L170.124 228.722L171.48 231.27L174.675 230.483L173.254 227.929Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M188.126 224.146L183.718 225.264L185.329 227.857L189.88 226.733L188.126 224.146Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M183.118 225.42L178.424 226.609L179.865 229.203L184.722 228.007L183.118 225.42Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M193.342 222.82L188.739 223.99L190.493 226.584L195.259 225.407L193.342 222.82Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M197.873 221.669L193.961 222.664L195.885 225.257L199.927 224.256L197.873 221.669Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M171.441 224.672L168.409 225.498L169.837 228.189L172.954 227.396L171.441 224.672Z",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M180.7 221.533L179.154 219.043L174.864 220.2L176.273 222.742L180.7 221.533Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M187.774 223.626L185.818 220.747L181.625 221.891L183.392 224.738L187.774 223.626Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M175.685 222.898L174.271 220.356L170.313 221.429L171.734 223.977L175.685 222.898Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M168.129 224.965L171.148 224.139L169.726 221.585L166.76 222.384L168.129 224.965Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M172.185 216.606L170.594 213.733L166.643 214.818L168.194 217.613L172.185 216.606Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M192.964 222.306L190.806 219.388L186.424 220.584L188.387 223.47L192.964 222.306Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M173.977 219.823L172.484 217.139L168.494 218.153L170.02 220.896L173.977 219.823Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M184.527 209.904L186.75 212.907L190.238 212.023L187.839 208.994L184.527 209.904Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M180.191 204.041L183.281 203.229L181.892 201.48L178.867 202.247L180.191 204.041Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M177.4 200.265L178.483 201.734L181.495 200.974L180.406 199.602L177.4 200.265Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M197.469 221.163L195.135 218.205L191.418 219.219L193.583 222.151L197.469 221.163Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M180.569 204.555L182.128 206.655L185.309 205.797L183.679 203.736L180.569 204.555Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M189.267 216.313L191.04 218.712L194.737 217.704L192.866 215.345L189.267 216.313Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M177.009 199.745L180.002 199.089L179.07 197.906L176.103 198.51L177.009 199.745Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M184.148 209.397L187.441 208.487L185.713 206.303L182.505 207.168L184.148 209.397Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M210.6 197.366V202.683C210.059 203.205 209.462 203.667 208.82 204.061C207.836 204.652 199.731 206.011 199.731 206.011L210.007 217.249C210.007 217.249 219.428 216.222 222.069 215.475C224.833 214.682 224.24 204.633 224.24 204.633L210.6 197.366Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210.6 197.366V202.683C210.6 202.683 210.457 202.826 210.222 203.034L222.239 215.423C224.807 214.272 224.24 204.652 224.24 204.652L210.6 197.366Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M192.416 129.376V185.737L235.507 219.628V132.528L192.416 129.376Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M195.382 132.333V179.822L231.555 202.091V135.486L195.382 132.333Z",
    fill: "#007A59",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M239.856 132.529H235.507V219.648H239.856V132.529Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M197.756 135.291L197.951 177.658L228.191 194.799V142.337L207.438 139.204L206.056 136.273L197.756 135.291Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M199.731 140.413V176.475L226.418 190.665V145.145L199.731 140.413Z",
    fill: "#007A59",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M215.339 175.611C219.104 174.351 220.744 169.136 219.002 163.963C217.26 158.79 212.795 155.619 209.03 156.879C205.265 158.139 203.625 163.354 205.367 168.527C207.109 173.7 211.574 176.872 215.339 175.611Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M212.974 166.835L215.51 164.034C215.681 163.784 215.769 163.487 215.761 163.185C215.752 162.883 215.649 162.591 215.464 162.35C215.086 161.811 214.493 161.7 214.16 162.084L211.722 164.781L209.277 160.881C208.925 160.316 208.331 160.14 207.973 160.491C207.784 160.724 207.676 161.012 207.667 161.311C207.658 161.611 207.747 161.905 207.921 162.149L210.457 166.211L207.875 169C207.704 169.25 207.617 169.548 207.626 169.85C207.636 170.153 207.741 170.444 207.927 170.683C208.076 170.919 208.309 171.088 208.579 171.158C208.697 171.187 208.82 171.183 208.935 171.146C209.05 171.109 209.153 171.041 209.231 170.95L211.676 168.252L214.115 172.152C214.265 172.418 214.513 172.614 214.806 172.698C214.919 172.734 215.039 172.738 215.154 172.71C215.268 172.683 215.374 172.625 215.458 172.542C215.645 172.309 215.75 172.02 215.759 171.721C215.767 171.422 215.677 171.129 215.503 170.885L212.974 166.835Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M204.472 152.633L219.416 157.008",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M203.878 148.492L223.249 153.881",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M217.231 241.351C217.231 241.351 207.783 242.222 204.289 245.011C200.794 247.799 203.415 249.197 206.734 250.068C210.052 250.939 224.925 249.541 226.848 247.624C228.771 245.706 226.848 241 217.231 241.351Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M226.848 247.65C227.22 247.28 227.45 246.793 227.5 246.272C223.269 246.064 217.72 247.286 212.68 248.872C210.979 249.412 209.251 249.865 207.503 250.23C211.898 250.757 225.049 249.418 226.848 247.65Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M183.738 137.904L190.642 141.486",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M179.773 135.85L181.827 136.916",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M185.257 155.948L187.598 156.215",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M176.298 154.915L182.61 155.643",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M186.731 172.686L178.907 174.85",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M117.697 243.672C117.697 243.672 141.417 233.227 154.17 232.44L163.474 252.935H93.2012L117.697 243.672Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M146.568 120.185C146.568 120.185 163.265 139.958 166.78 143.585C170.294 147.212 170.424 149.845 169.29 151.47C168.155 153.095 159.627 156.104 150.838 161.733C142.049 167.362 117.065 181.883 116.817 182.39C116.569 182.897 114.176 164.84 114.176 164.84L155.983 147.693L155.859 146.439L142.297 121.407L146.568 120.185Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M162.639 149.37L143.262 121.16L142.329 121.433L155.891 146.465L156.015 147.719L114.208 164.866C114.208 164.866 114.254 165.178 114.319 165.705L117.045 171.938L162.639 149.37Z",
    fill: "#007A59",
    fillOpacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M146.568 120.185C146.568 120.185 163.265 139.958 166.78 143.585C170.294 147.212 170.424 149.845 169.29 151.47C168.155 153.095 159.627 156.104 150.838 161.733C142.049 167.362 117.065 181.883 116.817 182.39C116.569 182.897 114.176 164.84 114.176 164.84L155.983 147.693L155.859 146.439L142.297 121.407L146.568 120.185Z",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M133.26 111.547C133.26 111.547 131.252 109.792 130.248 111.547C129.244 113.302 129.12 116.175 129.746 116.428C130.372 116.682 132.882 116.305 133.26 115.551C133.638 114.797 133.26 111.547 133.26 111.547Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M136.774 110.669C136.774 110.669 134.642 108.42 133.26 109.291C131.878 110.162 132.256 114.927 132.758 115.304C133.26 115.681 136.272 114.654 136.67 114.049C137.068 113.445 136.774 110.669 136.774 110.669Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M141.547 110.793C141.547 110.793 139.663 108.193 137.909 108.193C136.155 108.193 134.89 114.452 135.523 114.953C136.155 115.453 140.289 114.829 140.543 114.452C140.946 113.252 141.281 112.03 141.547 110.793V110.793Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 115.05C145.218 114.303 144.846 107.79 142.61 108.167C140.373 108.544 137.968 113.802 138.092 114.667C138.215 115.531 145.218 115.05 145.218 115.05Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M155.982 147.719C155.982 147.719 162.385 150.098 164.771 149.968Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M155.982 147.719C155.982 147.719 162.385 150.098 164.771 149.968",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M103.333 253.104C110.153 251.96 118.89 247.286 121.492 241.404C119.536 231.205 117.065 216.84 117.065 208.052C117.065 193.284 120.977 184.899 119.197 174.902C117.417 164.905 113.674 158.386 109.658 155.753C109.658 155.753 103.509 157.378 97.2307 163.261C90.9519 169.143 85.4295 179.257 83.2779 188.897C81.1263 198.536 78.2575 228.196 78.2575 235.957C78.2575 243.718 77.6968 253.351 77.6968 253.351C85.2143 253.351 92.7319 253.351 100.249 253.351C101.283 253.361 102.315 253.278 103.333 253.104V253.104Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M121.492 241.397C117.671 244.647 100.465 250.959 97.9544 251.518C95.4442 252.077 96.8395 246.786 100.745 241.501C104.65 236.217 95.9984 243.451 94.6031 244.004C93.2079 244.556 95.1639 233.708 95.1639 228.404C95.1639 223.1 100.191 178.042 100.191 178.042L109.677 160.784L112.937 158.834C112.027 157.627 110.926 156.576 109.677 155.721C109.677 155.721 103.529 157.346 97.2503 163.228C90.9715 169.111 85.4295 179.257 83.2779 188.897C81.1263 198.536 78.2575 228.196 78.2575 235.957C78.2575 243.718 77.6968 253.351 77.6968 253.351C85.2143 253.351 92.7319 253.351 100.249 253.351C101.279 253.351 102.307 253.26 103.32 253.078C110.153 251.96 118.89 247.286 121.492 241.397Z",
    fill: "#007A59",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M103.333 253.104C110.153 251.96 118.89 247.286 121.492 241.404C119.536 231.205 117.065 216.84 117.065 208.052C117.065 193.284 120.977 184.899 119.197 174.902C117.417 164.905 113.674 158.386 109.658 155.753C109.658 155.753 103.509 157.378 97.2307 163.261C90.9519 169.143 85.4295 179.257 83.2779 188.897C81.1263 198.536 78.2575 228.196 78.2575 235.957C78.2575 243.718 77.6968 253.351 77.6968 253.351C85.2143 253.351 92.7319 253.351 100.249 253.351C101.283 253.361 102.315 253.278 103.333 253.104V253.104Z",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M109.292 158.054L120.077 177.632L120.657 188.37C120.657 188.37 123.663 180.713 122.326 175.715C120.989 170.716 109.292 158.054 109.292 158.054Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M120.65 188.377L117.645 233.688L120.989 243.016L123.33 224.354L121.322 187.038L120.65 188.377Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M117.69 139.705C117.69 139.705 118.068 144.586 118.447 146.965C118.825 149.344 112.924 156 112.924 156L121.459 168.89L131.128 161.382C131.128 161.382 144.82 160.381 146.065 159.25C147.311 158.119 147.324 145.737 147.324 145.737L150.584 143.858C150.584 143.858 147.571 130.858 146.822 127.959L146.065 125.086C146.065 125.086 150.46 123.578 149.456 119.236C148.452 114.894 142.049 112.736 135.646 113.724C129.244 114.712 127.614 117.104 127.614 117.104C127.614 117.104 118.571 116.981 113.426 121.238C108.282 125.496 111.418 132.249 113.048 134.628C114.435 136.459 115.989 138.159 117.69 139.705V139.705Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M132.83 157.19C130.32 154.128 132.83 142.441 134.786 136.598C136.742 130.754 131.995 128.252 131.995 128.252L146.248 125.801L146.052 125.067C147.016 124.691 147.874 124.086 148.55 123.305L149.319 118.788C148.015 114.68 141.84 112.704 135.627 113.672C129.224 114.673 127.594 117.052 127.594 117.052C127.594 117.052 118.551 116.929 113.407 121.186C108.262 125.444 111.399 132.197 113.029 134.576C114.413 136.425 115.967 138.142 117.671 139.705C117.671 139.705 118.049 144.586 118.427 146.965C118.805 149.344 112.924 156 112.924 156L121.459 168.89L131.128 161.382C131.128 161.382 141.56 160.615 145.055 159.673L146.065 159.25C146.065 159.25 135.353 160.251 132.83 157.19Z",
    fill: "#007A59",
    fillOpacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M140.165 133.952C140.165 133.952 140.165 133.757 140.165 133.452C140.165 132.483 140.328 130.39 141.952 129.818C144.084 129.071 145.864 131.073 145.864 131.073L145.987 133.075C145.681 132.692 145.277 132.398 144.819 132.222C144.361 132.046 143.864 131.995 143.379 132.074C142.132 132.335 141.003 132.994 140.165 133.952V133.952Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M143.809 137.956C143.809 138.99 143.522 139.835 143.157 139.835C142.792 139.835 142.505 138.99 142.505 137.956C142.505 136.923 142.786 136.078 143.157 136.078C143.529 136.078 143.809 136.916 143.809 137.956Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M139.852 151.067C139.154 151.788 138.222 152.022 137.772 151.593C137.322 151.164 137.524 150.222 138.222 149.5C138.919 148.779 139.845 148.545 140.295 148.974C140.745 149.403 140.549 150.345 139.852 151.067Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M117.69 139.705C117.69 139.705 118.068 144.586 118.447 146.965C118.825 149.344 112.924 156 112.924 156L121.459 168.89L131.128 161.382C131.128 161.382 144.82 160.381 146.065 159.25C147.311 158.119 147.324 145.737 147.324 145.737L150.584 143.858C150.584 143.858 147.571 130.858 146.822 127.959L146.065 125.086C146.065 125.086 150.46 123.578 149.456 119.236C148.452 114.894 142.049 112.736 135.646 113.724C129.244 114.712 127.614 117.104 127.614 117.104C127.614 117.104 118.571 116.981 113.426 121.238C108.282 125.496 111.418 132.249 113.048 134.628C114.435 136.459 115.989 138.159 117.69 139.705V139.705Z",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M129.746 127.439C132.008 125.938 146.046 125.067 146.046 125.067C146.046 125.067 150.44 123.559 149.436 119.217C148.432 114.875 142.03 112.717 135.627 113.705C129.224 114.693 127.594 117.085 127.594 117.085C127.594 117.085 118.551 116.961 113.407 121.219C108.262 125.476 111.399 132.23 113.029 134.609C114.413 136.458 115.967 138.175 117.671 139.737C117.671 139.737 117.879 142.415 118.14 144.775L122.052 145.873L126.323 143.618L130.593 142.617C130.593 142.617 127.451 140.238 129.211 137.989C130.972 135.74 134.232 134.986 134.355 133.231C134.479 131.476 127.483 128.941 129.746 127.439Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M143.451 120.166C143.451 120.166 141.977 117.475 144.677 117.962C147.376 118.45 147.376 123.104 145.166 124.079C142.955 125.054 130.933 122.857 124.302 124.813C117.671 126.77 113.016 132.152 113.016 132.152",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M116.699 136.312C116.699 136.312 121.857 131.911 126.023 131.177C130.189 130.442 132.406 130.442 127.744 133.127C123.082 135.811 126.271 135.324 129.218 134.349",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M127.483 145.964C127.483 145.964 126.734 138.08 122.841 137.833C118.949 137.586 119.073 143.215 120.233 147.095C121.394 150.976 124.145 152.224 126.381 150.222",
    fill: "#007A59"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M127.483 145.964C127.483 145.964 126.734 138.08 122.841 137.833C118.949 137.586 119.073 143.215 120.233 147.095C121.394 150.976 124.145 152.224 126.381 150.222",
    fill: "#CCE4DE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M127.483 145.964C127.483 145.964 126.734 138.08 122.841 137.833C118.949 137.586 119.073 143.215 120.233 147.095C121.394 150.976 124.145 152.224 126.381 150.222",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 151.223L125.827 170.248L120.05 177.632C117.449 172.629 114.558 167.78 111.392 163.111C107.121 157.105 106.619 156.104 106.619 156.104L113.27 151.223Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 151.223L106.619 156.104C106.619 156.104 106.991 156.839 109.729 160.758L116.758 156.507L113.27 151.223Z",
    fill: "#007A59",
    fillOpacity: 0.2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 151.223L125.827 170.248L120.05 177.632C117.449 172.629 114.558 167.78 111.392 163.111C107.121 157.105 106.619 156.104 106.619 156.104L113.27 151.223Z",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M145.563 198.536C145.563 198.536 147.572 194.402 147.95 191.776C148.328 189.15 148.452 187.642 149.958 186.394C151.464 185.146 156.361 180.135 157.13 178.256C157.899 176.378 158.382 178.133 158.76 179.634C159.138 181.136 159.008 182.514 157.756 183.391C156.874 184.044 156.073 184.799 155.37 185.64L156.498 186.518C156.498 186.518 172.191 180.635 173.828 180.018C175.464 179.4 176.964 179.888 177.088 181.142C177.212 182.397 176.716 182.52 175.96 182.897C175.203 183.274 166.923 186.147 165.789 186.648L164.661 187.148L165.541 188.026C165.541 188.026 170.059 187.902 172.322 187.779C174.584 187.655 177.968 187.278 178.47 188.026C178.694 188.36 178.78 188.768 178.709 189.164C178.639 189.56 178.418 189.914 178.092 190.151C177.828 190.403 177.51 190.593 177.162 190.705C176.815 190.818 176.446 190.851 176.084 190.801C174.956 190.801 165.286 191.549 165.286 191.549L165.541 192.927C165.541 192.927 175.836 194.552 176.207 195.052C176.579 195.553 176.586 195.806 176.207 196.554C175.829 197.301 175.555 197.308 174.577 197.308C173.599 197.308 165.449 196.053 165.449 196.053C165.449 196.053 169.466 198.309 169.968 198.686C170.47 199.063 172.224 199.336 171.722 200.187C171.22 201.039 170.972 201.312 170.216 201.188C169.459 201.065 164.067 198.686 164.067 198.686C164.067 198.686 158.669 199.433 156.895 199.563C155.59 199.624 154.282 199.58 152.983 199.433L147.963 202.683L145.563 198.536Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M109.912 192.901C109.912 192.901 106.267 177.756 104.761 174.376C103.255 170.996 94.7202 167.876 90.5735 175.253C86.4268 182.631 90.1953 191.022 91.708 197.028C93.2206 203.034 102.753 230.178 104.135 233.578C105.517 236.977 108.047 236.178 109.41 235.833C110.772 235.489 148.954 204.789 148.954 204.789L145.941 198.036L116.314 213.2L109.912 192.901Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M108.843 226.2C109.81 223.27 110.926 220.391 112.187 217.575C113.583 214.793 105.491 223.977 103.816 218.966C102.14 213.954 91.5385 188.916 93.488 180.57C94.3336 176.693 96.6094 173.273 99.8645 170.989C96.7545 170.255 92.9468 171.035 90.5735 175.26C86.4333 182.644 90.1953 191.029 91.708 197.035C93.2206 203.041 102.753 230.185 104.135 233.584C105.517 236.984 108.047 236.184 109.41 235.84C110.414 235.567 130.926 219.232 142.01 210.373L108.843 226.2Z",
    fill: "#007A59",
    fillOpacity: 0.2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M109.912 192.901C109.912 192.901 106.267 177.756 104.761 174.376C103.255 170.996 94.7202 167.876 90.5735 175.253C86.4268 182.631 90.1953 191.022 91.708 197.028C93.2206 203.034 102.753 230.178 104.135 233.578C105.517 236.977 108.047 236.178 109.41 235.833C110.772 235.489 148.954 204.789 148.954 204.789L145.941 198.036L116.314 213.2L109.912 192.901Z",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M141.547 200.538L144.937 207.422",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9052 166.004L44.562 177.996C44.562 177.996 53.1097 187.005 52.2295 210.639C51.5775 228.69 53.9704 249.184 57.4455 253.351H75.9102C75.9102 253.351 69.5271 218.251 69.9835 198.14C70.3421 182.858 65.739 172.25 61.9052 166.004Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9916 166.004L46.6484 177.996C46.6484 177.996 55.1962 187.005 54.3094 210.639C53.6574 228.69 56.0503 249.184 59.5254 253.351H77.9966C77.9966 253.351 71.62 218.251 72.0764 198.14C72.422 182.858 67.8189 172.25 63.9916 166.004Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M61.905 166.004H63.9914L46.6482 177.996H44.5684L61.905 166.004Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData1);
export default __webpack_public_path__ + "static/media/NoData1.4f0e48bc4abdca62187f134123963bd6.svg";
export { ForwardRef as ReactComponent };